import * as React from 'react'
import { SVGProps } from 'react'

const SvgCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#checkIcon_svg__a)'>
      <path
        d='M5.18 13.726a2.01 2.01 0 0 1-1.425-.589L0 9.382l.95-.95 3.755 3.755a.672.672 0 0 0 .95 0l9.396-9.396.949.95-9.396 9.396a2.007 2.007 0 0 1-1.424.589Z'
        fill='#3071EE'
      />
    </g>
    <defs>
      <clipPath id='checkIcon_svg__a'>
        <path fill='#fff' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgCheckIcon
